<template>
  <v-container v-if="Object.keys(this.user).length > 0">
    <v-row v-if="details.length > 0">
      <v-col>
        <SectionTitle :title="label('sectionDetails')"/>
      </v-col>
    </v-row>
    <v-row v-if="details.length > 0">
      <v-col>
        <v-simple-table class="profile-table">
          <tbody>
            <tr v-for="(item, index) in details" :key="index">
              <td style="min-width: 270px; max-width: 270px; width: 270px;">
                {{item.name}} <v-icon v-if="item.secret" small class="icon">mdi-lock</v-icon>
              </td>
              <td style="white-space: pre-wrap;">{{item.value}}<span v-if="item.hint" class="overline"><br/>{{item.hint}}</span></td>
            </tr>
            <tr>
              <td style="min-width: 270px; max-width: 270px; width: 270px;">{{label('language')}}</td>
              <td >
                <div v-for="(item, index) in language" :key="index">
                  {{item}}
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="educations.length > 0">
      <v-col>
        <SectionTitle :title="label('sectionEducation')"/>
      </v-col>
    </v-row>
    <v-row v-if="educations.length > 0">
      <v-col>
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in educations" :key="index">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td>{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="careerHistory.length > 0">
      <v-col>
        <SectionTitle :title="label('careerHistory')"/>
      </v-col>
    </v-row>
    <v-row v-if="careerHistory.length > 0">
      <v-col>
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in careers" :key="index">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td>{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
        <CareerHistoryList :value="careerHistory" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SectionTitle :title="label('sectionRecuirement')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="isSide">
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in sideRequirementsTop" :key="index">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td>{{item.value}}</td>
          </tr>
          <tr>
            <td style="min-width: 270px; max-width: 270px; width: 270px;">希望勤務時間帯</td>
            <td>
              <ItemSelect :items="availabilityTimeList" :value="user.requirement.availabilityDaytime" label="平日昼" />
              <ItemSelect :items="availabilityTimeList" :value="user.requirement.availabilityEvening" label="平日夜" />
              <ItemSelect :items="availabilityTimeList" :value="user.requirement.availabilityHoliday" label="土日祝" />
            </td>
          </tr>
          <tr v-for="(item, index) in sideRequirementsBottom" :key="`bottom-${index}`">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td>{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col v-else>
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in requirements" :key="index">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td>{{item.value}}</td>
          </tr>
          <tr v-if="user.requirement.resourceType">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">働き方</td>
            <td>
              <ResourceTypeSlider :value="user.requirement.resourceType" />
              <DevelopmentTypeSlider :value="user.requirement.developmentType" />
              <CompanyScaleSlider :value="user.requirement.companyScale" />
              <WorkingStanceSlider :value="user.requirement.workingStance" />
            </td>
          </tr>
          <tr>
            <td>その他の希望条件</td>
            <td style="white-space: pre-wrap">{{user.requirement.otherRequirements}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SectionTitle :title="label('sectionPr')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in ownPrs" :key="index">
            <td style="min-width: 270px; max-width: 270px; width: 270px;">{{item.name}}</td>
            <td style="white-space: pre-wrap">{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <SectionTitle :title="label('sectionCompetitions')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <CompetitionSettings :userId="userId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from "../atoms/SectionTitle";
  import CareerHistoryList from "../molecules/CareerHistoryList";
  import {languages, remoteStatuses, hourlyWageItems, workingHoursWeekItems,} from "../../enums";
  import ComponentMixin from "../ComponentMixin";
  import _isNull from "lodash/isNull";
  import _isUndefined from "lodash/isUndefined";
  import _isArray from "lodash/isArray";
  import _join from "lodash/join";
  import _map from "lodash/map";
  import _isBoolean from "lodash/isBoolean";
  import CompetitionSettings from "@/components/organisms/CompetitionSettings";
  import ResourceTypeSlider from "@/components/molecules/ResourceTypeSlider"
  import DevelopmentTypeSlider from "@/components/molecules/DevelopmentTypeSlider";
  import CompanyScaleSlider from "@/components/molecules/CompanyScaleSlider";
  import WorkingStanceSlider from "@/components/molecules/WorkingStanceSlider";
  import ItemSelect from "@/components/molecules/ItemSelect";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "ProfileDetails",
    props: {
      "user": {
        type: Object,
        required: true
      },
      "consts": {
        type: Object,
        required: true
      },
      "isSide": {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      details () {
        const list = [
          { name: this.label("birthDate"), value: this.userAge, secret: false },
          { name: this.label("gender"), value: this.toText(this.user.gender, this.consts.gender), secret: false },
          { name: this.label("address"), value: this.address, secret: false },
          { name: this.label("salary"), value: this.salary() },
        ];
        return list;
      },
      requirements () {
        const list  = [
          { name: this.label("preferredLocations"), value: this.toText(this.user.requirement.location, this.consts.preferredLocation)},
          { name: "リモートワーク希望", value: this.user.requirement.remoteStatus ? 'フルリモートのみ' : 'なし' },
          { name: "今後やっていきたい・身を置きたい環境", value: this.user.requirement.environment },
        ]
        return list
      },
      sideRequirementsTop() {
        const list = [
          { name: "希望時間単価", value: this.toText(this.user.requirement.hourlyWage, hourlyWageItems.ja) },
          { name: "希望勤務時間/週", value: this.toText(this.user.requirement.workingHoursWeek, workingHoursWeekItems.ja) }
        ]
        return list
      },
      sideRequirementsBottom() {
        const list = [
          { name: "希望勤務地", value: this.toText(this.user.requirement.location, this.consts.preferredLocation) },
          { name: "リモート可否", value: this.toText(this.user.requirement.remoteStatus, remoteStatuses.ja) },
        ]
        return list
      },
      annualSalary() {
        return this.user.requirement.annualSalary ? this.user.requirement.annualSalary + " 万円" : ""
      },
      availabilityTimeList() {
        return [
          { label: '実働可', value: 1 },
          { label: '連絡可', value: 2 },
          { label: '連絡不可', value: 3 },
        ]
      },
      language () {
        const list = [];
        (this.user.detail.languages || []).forEach(ele => {
          if(ele.language === 99) {
            list.push(ele.otherLanguage + " : " + this.toText(ele.languageLevel, this.consts.languageLevel))
          } else {
            list.push( this.toText(ele.language, this.languages) + " : " + this.toText(ele.languageLevel, this.consts.languageLevel) )
          }
        });
        return list;
      },
      languages () {
        if (this.$i18n.locale === 'en'){
          return languages.en
        }
        return languages.ja
      },
      languageLevels () {
        return this.consts.languageLevels
      },
      educations () {
        const currentYear = new Date().getFullYear()
        return [
          { name: this.label("education"), value: this.toText(this.user.detail.academicHistory, this.consts.academics) },
          { name: this.label("school"), value: this.user.detail.schoolName },
          { name: this.label("faculty"), value: this.user.detail.department },
          { name: this.label("subject"), value: this.user.detail.departmentDetail },
          { name: this.label("enrollment"), value: currentYear < this.user.detail.graduatedYear ? '在学中' : '卒業' },
          { name: this.label("graduatedYear"), value: this.user.detail.graduatedYear },
        ]
      },
      isGraduated () {
        return this.user.detail.isGraduated ? 2 : 1;
      },
      careers () {
        return [
          { name: this.label("currentJob"), value: this.toText(this.user.currentJob, this.consts.currentJob) },
        ]
      },
      careerHistory () {
        return this.user.detail.careers || []
      },
      ownPrs () {
        return [
          { name: "自己紹介", value: this.user.pr.about },
          { name: this.label("dataGoodAt"), value: this.toText(this.user.pr.data, this.consts.dataGoodAt) },
          { name: this.label("domainGoodAt"), value: this.toText(this.user.pr.domains, this.consts.userDomain) },
          { name: this.label("programming"), value: this.toText(this.user.pr.programmingLanguages, this.consts.programmingLanguages) },
          { name: this.label("tools"), value: this.experiencedToolsLabel(this.user.pr.tools, this.user.pr.otherTools) },
        ]
      },
      toText () {
        return (value, items) => {
          if (_isNull(value) || _isUndefined(value) || _isNull(items) || _isUndefined(items)) {
            return ""
          }
          const label = (item) => {
            if (Array.isArray(item.label)) {
              return item.label[0]
            }
            return item.label
          }
          if (_isArray(value)) {
            return _join(_map(value, val => label(items.filter(item => item.value === val)[0])), ", ")
          } else if (_isBoolean(value)) {
            return label(items.filter(item => item.value === (value ? 1 : 0))[0])
          } else {
            const selectedItem = items.filter(item => item.value === value);
            if (selectedItem.length > 0) {
              return label(selectedItem[0]);
            }
            return "";
          }
        }
      },
      userAge () {
        return this.user.birthDate ? this.dateToText(this.user.birthDate) + "（"+ this.age(this.user.birthDate) +"歳）" : ""
      },
      address () {
        return this.user.detail.prefecture ? this.user.detail.zipCode + " " + this.toText(this.user.detail.prefecture, this.consts.prefectures) + this.user.detail.address : ""
      },
      salary () {
        return () => {
          return this.user.detail.salary ? (String(this.user.detail.salary) + " 万円") : "";
        }
      },
      userId () {
        return this.user.id
      }
    },
    components: {
      CompetitionSettings,
      SectionTitle,
      CareerHistoryList,
      ResourceTypeSlider,
      DevelopmentTypeSlider,
      CompanyScaleSlider,
      WorkingStanceSlider,
      ItemSelect,
    },
    methods: {
      experiencedToolsLabel(tools, otherTools) {
        const constsTools = this.consts.userServiceAndTool
        if (!constsTools) {
          return ''
        }
        const findItem = (tool) => constsTools.find((item) => item.value === tool)
        const toolLabels = tools
            .map((tool) => findItem(tool) ? findItem(tool).label : undefined)
            .join(', ')

        if (otherTools && otherTools.length > 0) {
          if (toolLabels) {
            return `${toolLabels}, ${otherTools}`
          }
          return `${otherTools}`
        }
        return toolLabels
      },
    }
  }
</script>

<style scoped lang="sass">
.profile-table
  margin: 0 16px
.icon
  padding-bottom: 4px
</style>
